import { render, staticRenderFns } from "./sapPromotion.vue?vue&type=template&id=30fc6c1a"
import script from "./sapPromotion.vue?vue&type=script&lang=js"
export * from "./sapPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports